import React from"react";
import { useNavigate } from"react-router-dom";

const players = [
 {
 rank: 1,
 name:"Rakesh",
 club:"Python",
 scores: [67, 66, 65, 62, 62],
 total: 65,
 change: 1,
 },
 {
 rank: 2,
 name:"Siya",
 club:"JavaScript",
 scores: [46, 79, 63, 60, 48],
 total: 63,
 change: -1,
 },
 {
 rank: 3,
 name:"Aarav",
 club:"Django",
 scores: [41, 69, 58, 63, 64],
 total: 58,
 change: 0,
 },
];

const Leaderboard = () => {
 const navigate = useNavigate();

 return (
 <div className="min-h-screen bg-bgMain flex items-center justify-center px-4 py-12 relative overflow-hidden">
 {/* Background decoration */}
 <div className="absolute top-0 right-0 w-96 h-96 bg-primary/5 rounded-full blur-3xl -mr-48 -mt-48"></div>
 
 {/* Back Button */}
 <div className="absolute top-8 left-8 z-10">
 <button
 onClick={() => navigate(-1)}
 className="px-6 py-2 bg-primary/10 text-primary border border-primary/30 font-bold rounded-full hover:bg-primary hover:text-white transition-all shadow-lg"
 >
 ← Back
 </button>
 </div>

 <div
 className="bg-bgSection p-8 md:p-10 rounded-3xl w-full max-w-5xl mt-16 border border-accentGray/30 shadow-2xl relative z-10 overflow-hidden"
 style={{ boxShadow:"0 0 40px rgba(37, 99, 235, 0.1)" }}
 >
 <div className="absolute top-0 right-0 w-64 h-64 bg-primary/5 rounded-full blur-3xl"></div>

 <h1 className="text-4xl md:text-5xl font-extrabold bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent mb-10 text-center">
 Leaderboard
 </h1>

 <div className="overflow-x-auto custom-scrollbar">
 <table className="w-full text-sm text-left">
 <thead className="bg-bgMain text-primary text-base">
 <tr>
 <th className="px-6 py-5 uppercase tracking-widest text-xs font-bold">Rank</th>
 <th className="px-6 py-5 uppercase tracking-widest text-xs font-bold">Player</th>
 <th className="px-6 py-5 uppercase tracking-widest text-xs font-bold">Language</th>
 <th className="px-6 py-5 uppercase tracking-widest text-xs font-bold">Scores</th>
 <th className="px-6 py-5 text-right uppercase tracking-widest text-xs font-bold">Total</th>
 </tr>
 </thead>
 <tbody className="divide-y divide-white/5">
 {players.map((player, idx) => (
 <tr
 key={idx}
 className="hover:bg-primary/5 transition-colors group"
 >
 <td className="px-6 py-5">
 <div className={`w-8 h-8 rounded-lg flex items-center justify-center font-extrabold ${
 idx === 0 ?"bg-primary text-white shadow-lg shadow-primary/20" :
 idx === 1 ?"bg-slate-300 text-black shadow-lg shadow-slate-300/20" :
 idx === 2 ?"bg-secondary text-white shadow-lg shadow-secondary/20" :
"bg-bgMain text-muted border border-accentGray/30"
 }`}>
 {player.rank}
 </div>
 </td>
 <td className="px-6 py-5 font-bold text-body group-hover:text-primary transition-colors">{player.name}</td>
 <td className="px-6 py-5">
 <span className="bg-primary/10 text-primary px-3 py-1 rounded-full font-bold text-xs uppercase tracking-tighter border border-primary/20">
 {player.club}
 </span>
 </td>
 <td className="px-6 py-5">
 <div className="flex space-x-2">
 {player.scores.map((score, i) => (
 <span
 key={i}
 className="bg-bgSection text-body/80 border border-accentGray/30 font-medium px-2 py-1 rounded-md text-xs"
 >
 {score}
 </span>
 ))}
 </div>
 </td>
 <td className="px-6 py-5 text-right">
 <span className="bg-gradient-to-r from-primary to-secondary text-white font-extrabold px-4 py-1.5 rounded-full text-sm shadow-xl">
 {player.total}
 </span>
 </td>
 </tr>
 ))}
 </tbody>
 </table>
 </div>
 </div>
 </div>
 );
};

export default Leaderboard;



